module dm.portal.services {

    angular.module("dm.portal.services")
        .service("dm.portal.services.usersClient", [
            "$http",
            "$q",
            "$log",
            ($http, $q, $log) =>
                new UsersClient($http, $q, $log)]);

    export interface IUsersClient {
        login: (username: string, password: string) => ng.IHttpPromise<{}>,
        resetPassword: (username: string) => ng.IHttpPromise<{}>,
        getCurrentUser: () => ng.IHttpPromise<ICurrentUserDTO>,
        changePassword: (oldPassword: string, newPassword: string) => ng.IHttpPromise<boolean>,
        setCmcCookies: () => ng.IHttpPromise<{}>,
        updateUser: (user: IUserDTO) => ng.IHttpPromise<IUserDTO>,
        getUsersByCompany: (legacyCompanyId: string) => ng.IHttpPromise<IUserDTO[]>,
        getUsersAssignableToWorkflow: (legacyCompanyId: string) => ng.IHttpPromise<IUserDTO[]>,
        getUsersByProject: (projectId: number) => ng.IHttpPromise<IUserDTO[]>,
        getUsersByReport: (reportId: number) => ng.IHttpPromise<IUserDTO[]>,
        getNetSuiteCustomerId: () => ng.IHttpPromise<string>;
        getNetSuiteCaseId: (caseNumber: string) => ng.IHttpPromise<string>;
    }

    class UsersClient implements IUsersClient {

        constructor(
            private $http: ng.IHttpService,
            private $q: ng.IQService,
            private $log: ng.ILogService) {
        }

        login = (username: string, password: string): ng.IHttpPromise<{}> => {
            return this.$http.post("/Login/Index", { username: username, password: password });
        }

        resetPassword = (username: string): ng.IHttpPromise<{}> => {
            return this.$http.post("/api/users/resetpassword", { Username: username });
        }

        getCurrentUser = (): ng.IHttpPromise<ICurrentUserDTO> => {
            return this.$http.get("/api/users/current");
        }

        changePassword = (oldPassword: string, newPassword: string): ng.IHttpPromise<boolean> => {
            var data = { OldPassword: oldPassword, NewPassword: newPassword };
            return this.$http.post("/api/users/current/changepassword", data);
        }

        setCmcCookies = (): ng.IHttpPromise<{}> => {
            return this.$http.get("/api/users/current/cmcCookies");
        }

        updateUser = (user: IUserDTO): ng.IHttpPromise<IUserDTO> => {
            return this.$http.put("/api/users/" + user.Id, user);
        }

        getUsersByCompany = (legacyCompanyId: string): ng.IHttpPromise<IUserDTO[]> => {
            var fullUrl = "/api/companies/" + legacyCompanyId + "/users";
            return this.$http.get<IUserDTO[]>(fullUrl);
        }

        getUsersAssignableToWorkflow = (legacyCompanyId: string): ng.IHttpPromise<IUserDTO[]> => {
            var fullUrl = "/api/companies/" + legacyCompanyId + "/users/assignableToWorkflow";
            return this.$http.get<IUserDTO[]>(fullUrl);
        }

        getUsersByProject = (projectId: number): ng.IHttpPromise<IUserDTO[]> => {
            var fullUrl = "/api/projects/" + projectId + "/users";
            return this.$http.get<IUserDTO[]>(fullUrl);
        }

        getUsersByReport = (reportId: number): ng.IHttpPromise<IUserDTO[]> => {
            var fullUrl = "/api/reports/" + reportId + "/users";
            return this.$http.get<IUserDTO[]>(fullUrl);
        }

        getNetSuiteCustomerId = (): ng.IHttpPromise<string> => {
            return this.$http.get<string>("/api/users/current/netSuite/customerId");
        }

        getNetSuiteCaseId = (caseNumber: string): ng.IHttpPromise<string> => {
            return this.$http.get<string>("/api/users/current/netSuite/cases/" + caseNumber);
        }
    }
}